import { render, staticRenderFns } from "./FacebookPage.vue?vue&type=template&id=00411b3a&scoped=true&"
import script from "./FacebookPage.vue?vue&type=script&lang=js&"
export * from "./FacebookPage.vue?vue&type=script&lang=js&"
import style0 from "./FacebookPage.vue?vue&type=style&index=0&id=00411b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00411b3a",
  null
  
)

export default component.exports